import { FC } from 'react';

import { CatalogProductCard } from '@components/product/CatalogProductCard';
import { useCatalogData } from '@contexts/catalog-data';
import { GAMStorageService } from '@services';
import TopBar from '../TopBar/TopBar';
import CatalogPagination from './catalog-pagination/CatalogPagination';

import classes from './ProductCatalog.module.scss';

interface IProductCatalogProps {
  notFoundMessage?: string;
  pageTitle?: string;
}

interface IItemsNotFound {
  notFoundMessage?: string;
}

const ItemsNotFound: FC<IItemsNotFound> = ({ notFoundMessage }) => {
  return (
    <div className={classes.itemNotFound}>
      {notFoundMessage || 'За наданими параметрами фільтрації товарів не знайдено'}
    </div>
  );
};

const ProductCatalog: FC<IProductCatalogProps> = ({ notFoundMessage, pageTitle }) => {
  const { catalog } = useCatalogData();
  const products = catalog?.docs;

  const onCardClick = (id: string, index: number) => {
    GAMStorageService.setToStore({ [id]: { index: index + 1, item_list_name: pageTitle || 'product' } });
  };

  return (
    <section className={classes.wrapper}>
      <TopBar />
      {products?.length === 0 ? <ItemsNotFound notFoundMessage={notFoundMessage} /> : null}
      <article className={classes.container}>
        {products
          ? products.map((product, index) => (
              <CatalogProductCard
                onCardClick={onCardClick}
                index={index}
                key={`product-card-${index}-${product.id}`}
                item={product}
                imagePriority={index < 4}
              />
            ))
          : null}
      </article>
      {products?.length ? <CatalogPagination /> : null}
    </section>
  );
};

export default ProductCatalog;
